<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="submitForm"
            >
                <v-card-title
                    class="teal darken-1 white--text"
                >
                    Do you really want to disable this account?
                </v-card-title>
                <v-card-text style="padding: 20px;">
                    <v-text-field
                        v-model="data['PROVIDER NAME']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="Provider Name"
                    />
                    <v-text-field
                        v-model="data['MSU']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="MSU Code"
                    />
                    <v-text-field
                        v-model="data['PIC NAME']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="PIC Name"
                    />
                    <v-text-field
                        v-model="data['USERNAME']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="Username"
                    />
                    <v-text-field
                        v-model="data['EMAIL']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="Email"
                    />
                    <v-text-field
                        v-model="data['CONTACT NO.']"
                        disabled
                        color="teal darken-1"
                        dense
                        outlined
                        label="Contact Number"
                    />
                    <v-textarea
                        ref="reason"
                        v-model="reason"
                        clearable
                        color="teal darken-1"
                        outlined
                        label="Reason"
                        :rules="[ v => !!v || 'Reason is required' ]"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        color="teal darken-1"
                        style="text-transform: none; width: 105px;"
                        @click="$emit('closeDialog')"
                    >
                        CLOSE
                    </v-btn>
                    <v-btn
                        color="teal darken-3 white--text"
                        style="text-transform: none; width: 105px; font-weight: 600"
                        type="submit"
                    >
                        PROCEED
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'data'],
    data: ()=>({
        valid: false,
        reason: null
    }),
    computed: {
        showDialog: {
            ...mapGetters(['disableProviderAccountData']),
            get() {
                if (this.show === false) {
                    this.resetReason()
                }
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        ...mapActions(['disableProviderAccount']),
        resetReason() {
            if (this.$refs && this.$refs.reason) {
                this.$refs.reason.reset()
            }
        },
        submitForm() {
            if (this.$refs.form && this.$refs.form.validate()) {
                this.disableProviderAccount({ ID: this.data.ID, REASON: this.reason })
            }
        }
    }
}
</script>
